module.exports = __webpack_public_path__ + "img/newsletter-logo.ad9a6044.svg";